/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SwitchesConnectionsActivateRequest } from '../models/SwitchesConnectionsActivateRequest';
import type { SwitchesConnectionsActivateResponse } from '../models/SwitchesConnectionsActivateResponse';
import type { SwitchesConnectionsInactivateRequest } from '../models/SwitchesConnectionsInactivateRequest';
import type { SwitchesConnectionsInactivateResponse } from '../models/SwitchesConnectionsInactivateResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SwitchesConnectionsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Activate a connection between a source and and destination
     * Activate a connection between a source and and destination. (Access: all)
     * @returns SwitchesConnectionsActivateResponse Switch connection state
     * @returns any Unexpected error
     * @throws ApiError
     */
    public activateSwitchConnection({
        requestBody,
    }: {
        /**
         * Connection's information
         */
        requestBody: SwitchesConnectionsActivateRequest,
    }): CancelablePromise<SwitchesConnectionsActivateResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/switches/connections/activate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Inactivate a connection between a source and and destination
     * Inactivate a connection between a source and and destination. (Access: all)
     * @returns SwitchesConnectionsInactivateResponse Switch connection state
     * @returns any Unexpected error
     * @throws ApiError
     */
    public inactivateSwitchConnection({
        requestBody,
    }: {
        /**
         * Connection's information
         */
        requestBody: SwitchesConnectionsInactivateRequest,
    }): CancelablePromise<SwitchesConnectionsInactivateResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/switches/connections/inactivate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
}
